var _a;
import { termsApi } from './termsApi';
import { termsSlice } from './termsSlice';
export var reducers = (_a = {},
    _a[termsSlice.name] = termsSlice.reducer,
    _a[termsApi.reducerPath] = termsApi.reducer,
    _a);
export var middleware = [termsApi.middleware];
